import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('categories', storeModule.createStoreModule('categories'))
